<template>
  <WebsitePopupComponent v-model="isActive"
    popup-body-class="pb-1"
    :has-footer-slot="hasFooterSlot"
    is-closeable
    :class="popupClass"
    @close-button-clicked="closeBookingModal"
    >
    <template v-if="isFirstStepActive && patientBooking">
      <div class="ow-patient-booking-popup-text">
        <h3 class="text-center mt-0">
          Choose your preferred date and time to book your screening.
        </h3>
        <!-- <h2>Common ocular diseases detectable through fundus photography:</h2>
        <p>Diabetic retinopathy / Age-related macular degeneration / Retinitis pigmentosa / Glaucoma / Optic neuritis / Retinal detachment / Retinal vein occlusion /</p>
        <p>Retinal artery occlusion / Fundus tumors / Hypertensive retinopathy</p>
        <h2>Retinal diseases like:</h2>
        <p>Dystrophies / Peripheral retinal degenerations / Retinal holes, tears and atrophic changes / Lid diseases / Skin cancers / Intraocular tumors / Vitreous hemorrhages </p> -->
        <!-- <p style="color: #a2a5a8;">
          and more
        </p> -->
      </div>
      <!-- <div class="hr-divider is-center gap-2">
        BOOK YOUR SCREENING
      </div> -->
      <div id="select-wrapper"
        style="display: flex; width: 100%; padding-inline: 30px; box-sizing: border-box; gap: 30px; padding-bottom: 30px; flex-wrap: wrap;"
        >
        <InputSelect v-model="selectedDateOfScreening"
          :values="datesWithFreeTimeslots"
          label="Select a date"
          is-required
          style="flex: 1; min-width: 200px;"
          relative-container=".ow-popup-body"
          />
        <InputSelect v-model="patientBooking.timeslot"
          :values="freeTimeslotsValues"
          label="Select a timeslot"
          is-required
          style="flex: 1; min-width: 200px;"
          relative-container=".ow-popup-body"
          :is-disabled="isTimeSlotSelectDisabled"
          />
      </div>
      <div class="ow-patient-booking-submit-wrapper" style="margin-top: auto;">
        <button class="ow-patient-booking-button button-primary"
          :disabled="isFirstStepButtonDisabled"
          @click="saveCalendarTimeslotAndSwitchToBooking"
          >
          NEXT
        </button>
      </div>
    </template>
    <template v-else-if="isSecondStepActive && patientBooking">
      <div class="ow-patient-details-wrapper os-grid">
        <div class="ow-patient-booking-popup-text os-grid-cell cols-12">
          <h3 class="text-center mt-0">
            Patient Information - Please complete all required fields to proceed with your screening booking
          </h3>
        </div>
        <!-- <div class="hr-divider is-center gap-2 os-grid-cell cols-12 mt-1">
          PATIENT DETAILS
        </div> -->
        <InputSelect v-model="patientBooking.patient.fk_country"
          label="Country"
          placeholder="Select your country"
          widget-class="os-grid-cell cols-5-lg"
          relative-container=".ow-popup-body"
          is-required
          :values="countryValues"
          />
        <InputSelect v-model="patientBooking.patient.document_type"
          relative-container=".ow-popup-body"
          is-required
          label="Document type"
          placeholder="Select your document type"
          widget-class="os-grid-cell cols-3-lg"
          :values="documentTypeValues"
          :is-disabled="documentTypeField.isDisabled"
          />
        <InputText v-model="patientBooking.patient.identity_number"
          label="ID"
          placeholder="Enter your document number"
          widget-class="os-grid-cell cols-4-lg"
          is-required
          :validation-rules="identityNumberValidationRules"
          :is-disabled="identityNumberField.isDisabled"
          @is-valid="lookupPatient"
          />
        <InputSelect v-model="patientBooking.patient.title"
          label="Title"
          placeholder="Select..."
          relative-container=".ow-popup-body"
          widget-class="os-grid-cell cols-2-lg"
          is-required
          :values="['Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Prof']"
          :is-disabled="titleField.isDisabled"
          />
        <InputText v-model="patientBooking.patient.name"
          label="Name"
          placeholder="Enter your name"
          widget-class="os-grid-cell cols-4-lg"
          is-required
          :is-disabled="nameField.isDisabled"
          />
        <InputText v-model="patientBooking.patient.surname"
          label="Surname"
          placeholder="Enter your surname"
          widget-class="os-grid-cell cols-4-lg"
          is-required
          :is-disabled="surnameField.isDisabled"
          />
        <InputSelect v-model="patientBooking.patient.sex"
          is-required
          relative-container=".ow-popup-body"
          label="Gender"
          placeholder="Select..."
          :values="[{ displayValue: 'Male', dataValue: 'male' }, { displayValue: 'Female', dataValue: 'female' }, { displayValue: 'Other', dataValue: 'other' }]"
          widget-class="os-grid-cell cols-2-lg"
          :is-disabled="sexField.isDisabled"
          />
        <InputDate v-model="patientBooking.patient.dob"
          label="Date of birth"
          widget-class="os-grid-cell cols-2-lg"
          is-required
          :is-disabled="dobField.isDisabled"
          />
        <InputText v-model="patientAge"
          label="Age"
          widget-class="os-grid-cell cols-1-lg"
          is-disabled
          />
        <InputText v-model="patientBooking.patient.email"
          label="Email"
          type="email"
          placeholder="Enter your email"
          widget-class="os-grid-cell cols-3-lg"
          is-required
          :is-disabled="emailField.isDisabled"
          />
        <InputText v-model="patientBooking.patient.patient_address"
          label="Physical address"
          placeholder="Enter your physical address"
          widget-class="os-grid-cell cols-3-lg"
          :is-disabled="addressField.isDisabled"
          />
        <InputText v-model="patientBooking.patient.occupation"
          label="Occupation"
          placeholder="Enter your occupation"
          widget-class="os-grid-cell cols-2-lg"
          :is-disabled="occupationField.isDisabled"
          />
        <InputPhone v-model="patientBooking.patient.cell_phone"
          label="Phone number"
          placeholder="Enter your phone number"
          widget-class="os-grid-cell cols-4-lg"
          default-country-code="+27"
          relative-container=".ow-popup-body"
          :top-country-codes="['+27', '+264']"
          is-required
          :is-disabled="cellPhoneField.isDisabled"
          />
        <InputSelect v-model="patientBooking.patient.payment_type"
          label="Medical Aid"
          placeholder="Select..."
          widget-class="os-grid-cell cols-4-lg"
          relative-container=".ow-popup-body"
          is-required
          :values="[
            { dataValue: 'Medical Aid', displayValue: 'Yes' },
            { dataValue: 'Private', displayValue: 'No' },
          ]"
          :is-disabled="maidField.isDisabled"
          @value-updated="paymentTypeUpdated"
          />
        <div class="ow-patient-booking-submit-wrapper os-grid-cell cols-12">
          <button class="ow-patient-booking-button button-primary"
            :disabled="isPatientDetailsSubmitButtonDisabled"
            @click="savePatientDetailsAndContinue"
            >
            {{ secondStepButtonText }}
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="isThirdStepActive && patientBooking">
      <div class="ow-patient-details-wrapper medical-aid-wrapper os-grid">
        <div class="ow-patient-booking-popup-text os-grid-cell cols-12">
          <h3 class="text-center mt-0">
            Please complete all medical aid details.
          </h3>
        </div>
        <InputSelect v-model="patientBooking.patient.fk_medical_aid"
          is-required
          relative-container=".ow-popup-body"
          label="Medical Aid Name"
          placeholder="Select..."
          :values="mAidNameValues"
          widget-class="os-grid-cell cols-3-md"
          @value-updated="mAidNameSelected"
          />
        <InputSelect v-model="patientBooking.patient.fk_medical_aid_plan"
          :is-disabled="isMAidPlanDisabled"
          is-required
          relative-container=".ow-popup-body"
          label="Medical Aid Plan"
          placeholder="Select..."
          :values="mAidPlanValues"
          widget-class="os-grid-cell cols-3-md"
          />
        <InputSelect v-model="patientBooking.patient.member_type"
          :is-disabled="isMemberTypeDisabled"
          is-required
          relative-container=".ow-popup-body"
          label="Member type"
          placeholder="Select..."
          :values="['Main member', 'Dependant']"
          widget-class="os-grid-cell cols-3-md"
          />
        <InputText v-model="patientBooking.patient.m_aid_number"
          :is-disabled="isMAidNumberDisabled"
          is-required
          label="Medical Aid Number"
          placeholder="Enter your Medical Aid number"
          widget-class="os-grid-cell cols-3-md"
          />
        <InputText v-model="patientBooking.patient.dependant_code"
          :is-disabled="isMaidDependantCodeDisabled"
          label="Dependant code"
          placeholder="Enter your Dependant code"
          widget-class="os-grid-cell cols-3-md"
          />
        <div class="ow-patient-booking-submit-wrapper os-grid-cell cols-12">
          <button class="ow-patient-booking-button button-primary"
            :disabled="isMAidStepSubmitButtonDisabled"
            @click="saveMAidDetailsAndContinue"
            >
            SUBMIT
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="isFourthStepActive && patientBooking">
      <div class="ow-patient-booking-final-step">
        <div class="ow-patient-booking-final-step-header">
          <h2 class="text-center text-important">
            Please review the information below.
          </h2>
          <!-- <h2 class="text-center text-primary">
            Details of your booking with the {{ patientBooking.screeningCentre.name }}
          </h2>
          <h3 class="text-center text-primary">
            You will receive email and SMS with the confirmation of your appointment
          </h3> -->
        </div>
        <ul class="ow-patient-booking-cards-list">
          <li v-for="booking in completedBookings" :key="booking.tempId" class="ow-patient-booking-card ow-patient-booking-final-step-box">
            <span class="ow-patient-booking-card-text">
              <b>Name:</b> {{ booking.patient.title }} {{ booking.patient.name }} {{ booking.patient.surname }}
            </span>
            <span class="ow-patient-booking-card-text">
              <b>Screening Centre:</b> {{ booking.screeningCentre.name }}
            </span>
            <span class="ow-patient-booking-card-text">
              <b>Screening Centre Address:</b> {{ booking.screeningCentre.address }}
            </span>
            <span class="ow-patient-booking-card-text"><b>Date:</b> {{ format(new Date(booking.timeslot.start), 'dd/MM/yyyy') }}</span>
            <span class="ow-patient-booking-card-text"><b>Time:</b> {{ format(new Date(booking.timeslot.start), 'HH:mm') }}</span>
            <div class="ow-patient-booking-card-buttons">
              <button class="ow-patient-booking-card-button" @click="editBooking(booking)">
                <span class="os-icon icon-pen"></span>
              </button>
              <button class="ow-patient-booking-card-button" @click="deleteBooking(booking)">
                <span class="os-icon icon-trash"></span>
              </button>
            </div>
          </li>
        </ul>
        <div class="ow-patient-booking-final-step-buttons mt-1 os-columns mb-2">
          <div class="ow-book-another os-columns is-multiline mt-4 mb-1 gap-2">
            <h3 class="os-column is-12 my-0 py-0 text-center text-primary">
              Make a booking for another person
            </h3>
            <button class="ow-patient-booking-button button-primary os-column" @click="bookForAnotherPersonAtSameSc()">
              At the same screening centre
            </button>
            <button class="ow-patient-booking-button button-primary os-column" @click="bookForAnotherPersonAtDifferentSc()">
              At a different screening centre
            </button>
          </div>
          <div class="ow-or text-primary text-bold">
            OR
          </div>
          <div class="ow-finish os-columns">
            <button class="ow-patient-booking-button os-column button-primary"
              @click="finishBooking"
              >
              Finish
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="isFifthStepActive">
      <div class="ow-patient-booking-final-step-header">
        <h3 class="text-center text-primary">
          Thank you! Your OxIA screening appointment has been confirmed. A confirmation email will be sent to you shortly.
        </h3>
      </div>
      <button class="ow-patient-booking-button os-column button-primary mb-5" @click="closeBookingPopup">
        Confirm
      </button>
    </template>
    <template #popupFooterSlot>
      <div class="ow-patient-booking-footer">
        <button v-if="isStepBackVisible"
          :disabled="isStepBackDisabled"
          class="ow-patient-booking-step-back-button"
          @click="stepBack()"
          >
          <span class="os-icon icon-back"></span>
          <span class="ow-patient-booking-step-back-button-text">Back</span>
        </button>
        <ul v-if="hasFooterSlot" class="ow-patient-booking-steps">
          <li class="ow-patient-booking-step" :class="{ 'is-active': currentStep === 1 }"></li>
          <li class="ow-patient-booking-step" :class="{ 'is-active': currentStep === 2 }"></li>
          <li v-if="isMedicalAidSelected" class="ow-patient-booking-step" :class="{ 'is-active': currentStep === 3 }"></li>
        </ul>
      </div>
    </template>
  </WebsitePopupComponent>
</template>

<script setup lang="ts">
import type { ISelectValue } from '@oxia/client';
import { format, formatDistanceToNowStrict } from 'date-fns';
import { computed, ref, watch } from 'vue';

import { useNuxtApp } from '#app';
import type { IMedicalAidName, IMedicalAidPlan } from '~~/shared/types/interfaces';

const { $useDialog } = useNuxtApp();

const isActive = defineModel({ type: Boolean, default: false });
const completedBookings = defineModel<IPatientBooking[]>('completedBookings', { type: Array, default: [] });

interface IPatientBookingComponent {
  screeningCentre?: ISubOrganization
}

const props = defineProps<IPatientBookingComponent>();

const emit = defineEmits(['bookingFinished', 'popupClosed']);

// STEPS

const currentStep = ref(1);

const isFirstStepActive = computed(() => {
  return currentStep.value === 1;
});

const isSecondStepActive = computed(() => {
  return currentStep.value === 2;
});

const isThirdStepActive = computed(() => {
  return currentStep.value === 3;
});

const isFourthStepActive = computed(() => {
  return currentStep.value === 4;
});

const isFifthStepActive = computed(() => {
  return currentStep.value === 5;
});

const hasFooterSlot = computed(() => {
  return currentStep.value !== 4 && currentStep.value !== 5;
});

const isTimeSlotSelectDisabled = computed(() => {
  return !selectedDateOfScreening.value;
});
/** Based on the number of the step this function controls the screening process */
const switchToStep = (step: number) => {
  if (!isActive.value) isActive.value = true;
  currentStep.value = step;
  if (furthestStepReached.value < step) furthestStepReached.value = step;

  if (step === 4 && patientBooking.value) {
    if (!completedBookings.value.some(booking => booking.tempId === patientBooking.value.tempId)) {
      completedBookings.value.push(patientBooking.value);
    }
  }
};

// BOOKING
interface ITimeslot {
  weekday: string
  start: string
  end: string
}

export interface IPatientBooking {
  tempId: string
  timeslot: ITimeslot
  screeningCentre?: ISubOrganization
  patient: IPatient
  patientId?: string
}

const patientBooking = ref<IPatientBooking>();

const selectedScreeningCentre = computed(() => {
  return props.screeningCentre;
});

const getPatientBookingInitialState = (shouldResetSC?: boolean) => {
  const initialPatientBookingState = {
    tempId: window && window.crypto ? window.crypto.randomUUID() : '',
    timeslot: {} as ITimeslot,
    patient: {
      title: '',
      name: '',
      surname: '',
      sex: '',
      dob: null,
      fk_country: '',
      document_type: '',
      identity_number: '',
      occupation: '',
      email: '',
      patient_address: '',
      cell_phone: { number: '+27', countryCode: '+27' },
      payment_type: '',
      fk_medical_aid: '',
      fk_medical_aid_plan: '',
      member_type: '',
      m_aid_number: '',
      dependant_code: ''
    }
  } as IPatientBooking;
  if (shouldResetSC) {
    initialPatientBookingState.screeningCentre = {
      name: '',
      _id: '',
      address: ''
    };
  }
  else if (selectedScreeningCentre.value) {
    initialPatientBookingState.screeningCentre = { ...selectedScreeningCentre.value };
  }

  return initialPatientBookingState;
  // return {
  // timeslot: {
  //   start: new Date().toString(),
  //   end: new Date().toString()
  // } as ITimeslot,
  // screeningCentre: {
  //   name: 'Oxia screening center',
  //   _id: '2323grt45r'
  // },
  // patient: {
  //   title: 'Mr',
  //   name: 'Stefan',
  //   surname: 'Obradovic',
  //   sex: 'mekanik',
  //   dob: new Date(),
  //   country: 'South Africa',
  //   documentType: 'ID',
  //   identityNumber: '123123',
  //   occupation: '',
  //   email: 'stefan@oxia.org',
  //   patientAddress: 'Address',
  //   cellPhone: { number: '+381629661951', countryCode: '+381' },
  //   paymentType: 'Private',
  //   mAidName: '',
  //   mAidPlan: '',
  //   memberType: '',
  //   mAidNumber: ''
  // }
  // };
};

const isMedicalAidSelected = computed(() => {
  return patientBooking.value && patientBooking.value.patient.payment_type === 'Medical Aid';
});

watch(() => isActive.value, async (newVal) => {
  if (newVal) {
    patientBooking.value = getPatientBookingInitialState();
    freeTimeslots.value = await getFreeTimeslots();
    await getMedicalAidNames();
  }
});

// CALENDAR STEP
const selectedDateOfScreening = ref();
const freeTimeslots = ref<ITimeslot[]>();
const selectedTimeSlot = ref<ITimeslot>();

const isFirstStepButtonDisabled = computed(() => {
  return !patientBooking.value?.timeslot.start;
});

const datesWithFreeTimeslots = computed(() => {
  const dates: { displayValue: string, dataValue: Date }[] = [];
  if (freeTimeslots.value) {
    freeTimeslots.value.forEach((timeslot) => {
      const alreadyAddedDate = dates.some((date) => {
        const existingDate = new Date(date.dataValue).toDateString();
        const timeslotDate = new Date(timeslot.start).toDateString();
        return existingDate === timeslotDate;
      });
      if (!alreadyAddedDate) {
        dates.push({
          displayValue: format(timeslot.start, 'dd/MM/yyyy'),
          dataValue: new Date(timeslot.start)
        });
      }
    });
  }
  return dates;
});

const freeTimeslotsValues = computed(() => {
  if (selectedDateOfScreening.value) {
    const selectedDateTimeslots = freeTimeslots.value?.filter((timeslot) => {
      return new Date(timeslot.start).toDateString() === selectedDateOfScreening.value?.toDateString();
    });
    return selectedDateTimeslots?.map((timeslot) => {
      return { displayValue: `${format(timeslot.start, 'HH:mm')} - ${format(timeslot.end, 'HH:mm')}`, dataValue: timeslot };
    });
  }
  return [];
});

const getFreeTimeslots = async (date?: Date) => {
  const requestBody = {
    screeningCenterId: props.screeningCentre?._id
  };
  if (date) {
    requestBody.date = date;
  }
  else {
    requestBody.days = 30;
  }
  const response = await $fetch('/api/endpoints/get-free-timeslots', {
    method: 'POST',
    body: requestBody
  });

  return response as ITimeslot[];
};

const saveCalendarTimeslotAndSwitchToBooking = () => {
  // if (selectedTimeSlot.value && patientBooking.value) patientBooking.value.timeslot = selectedTimeSlot.value;
  switchToStep(2);
};

const screeningDateUpdated = async (date: Date) => {
  freeTimeslots.value = await getFreeTimeslots(date.target.value);
};

// PATIENT STEP

const isIdentityNumberValid = computed(() => {
  if (patientBooking.value) {
    const selectedCountry = patientBooking.value.patient.fk_country;
    const selectedDocumentType = patientBooking.value.patient.document_type;
    const identityNumber = patientBooking.value.patient.identity_number;
    if (selectedCountry === 'South Africa' && selectedDocumentType === 'ID') {
      return identityNumber.length === 13;
    }
    else if (selectedCountry !== 'South Africa' || selectedDocumentType !== 'ID') {
      return identityNumber.length > 0;
    }
  }
  return false;
});

const isPatientDetailsReadonly = computed(() => {
  return !isIdentityNumberValid.value;
});

// FIELDS STATE AND VISIBILITY
const documentTypeField = computed(() => {
  return {
    isDisabled: !patientBooking.value?.patient.fk_country
  };
});
const identityNumberField = computed(() => {
  return {
    isDisabled: !patientBooking.value?.patient.document_type
  };
});
const titleField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const nameField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const surnameField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const sexField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const dobField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const emailField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const addressField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const occupationField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const cellPhoneField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});
const maidField = computed(() => {
  return {
    isDisabled: isPatientDetailsReadonly.value
  };
});

const identityNumberValidationRules = computed(() => {
  if (patientBooking.value?.patient.fk_country === 'South Africa' && patientBooking.value.patient.document_type === 'ID') return { min: 13, max: 13 };
  return {};
});

const patientAge = computed(() => {
  if (patientBooking.value?.patient.dob) {
    return formatDistanceToNowStrict(new Date(patientBooking.value.patient.dob), { roundingMethod: 'floor' });
  }
  return '';
});

const countryValues = computed(() => {
  return ['South Africa', 'Namibia', 'Serbia'];
});

const documentTypeValues = computed(() => {
  return ['ID', 'Passport', 'Other'];
});

const secondStepButtonText = computed(() => {
  return isMedicalAidSelected.value ? 'NEXT' : 'SUBMIT';
});

const isPatientDetailsSubmitButtonDisabled = computed(() => {
  const requiredPatientFields = [
    'title', 'name', 'surname', 'sex', 'dob', 'country', 'document_type', 'identity_number', 'email', 'cell_phone', 'payment_type'
  ];
  return requiredPatientFields.some(field => patientBooking.value?.patient[field] === '' || patientBooking.value?.patient[field] === null);
});

const paymentTypeUpdated = (paymentType: string) => {
  if (patientBooking.value && patientBooking.value.patient.payment_type === 'Private') {
    patientBooking.value.patient.fk_medical_aid = '';
    patientBooking.value.patient.fk_medical_aid_plan = '';
    patientBooking.value.patient.member_type = '';
    patientBooking.value.patient.m_aid_number = '';
  }
};

const savePatientDetailsAndContinue = () => {
  let nextStep = 4;
  if (isMedicalAidSelected.value) nextStep = 3;
  switchToStep(nextStep);
};

// MEDICAL AID STEP

const mAidNameValues = ref<ISelectValue[]>([]);
const mAidPlanValues = ref<ISelectValue[]>([]);

const isMAidPlanDisabled = computed(() => {
  return patientBooking.value?.patient.fk_medical_aid === '';
});

const isMemberTypeDisabled = computed(() => {
  return patientBooking.value?.patient.fk_medical_aid_plan === '';
});

const isMAidNumberDisabled = computed(() => {
  return patientBooking.value?.patient.member_type === '';
});

const isMaidDependantCodeDisabled = computed(() => {
  return patientBooking.value?.patient.member_type === '';
});

const isMAidStepSubmitButtonDisabled = computed(() => {
  const mAidFields = [
    'fk_medical_aid', 'fk_medical_aid_plan', 'member_type', 'm_aid_number'
  ];
  return mAidFields.some(field => patientBooking.value?.patient[field] === '' || patientBooking.value?.patient[field] === null);
});

const saveMAidDetailsAndContinue = () => {
  switchToStep(4);
};

const finishBooking = () => {
  emit('bookingFinished');
  switchToStep(5);
};

const closeBookingPopup = () => {
  isActive.value = false;
  emit('popupClosed');
  resetBooking(true);
};

// STEPS
const furthestStepReached = ref(1);

const isStepBackDisabled = computed(() => {
  return currentStep.value === 1;
});

const currentPatientExists = computed(() => {
  if (patientBooking.value?.patientId) return true;
  return false;
});

const isStepBackVisible = computed(() => {
  return furthestStepReached.value > 1 && currentStep.value !== 1 && currentStep.value !== 5 && !currentPatientExists.value;
});

const popupClass = computed(() => {
  return (currentStep.value !== 5) ? 'is-full-page' : '';
});

const stepBack = () => {
  if (currentStep.value === 4 && isMedicalAidSelected.value) switchToStep(3);
  else if (currentStep.value === 4 && patientBooking.value && patientBooking.value.patient.payment_type === 'Private') switchToStep(2);
  else switchToStep(currentStep.value - 1);
};

const closeBookingModal = async () => {
  try {
  // USING DIALOG ASK IF THEY WANT TO SAVE STATE OR CLEAR OR CANCEL
    const shouldCloseModal = await $useDialog().show({
      title: 'Are you sure you want to close',
      message: 'This action is irreversable. You will lose the entered data',
      confirmButton: {
        text: 'Close',
        class: 'os-button button-default is-half'
      },
      cancelButton: {
        text: 'Cancel',
        class: 'os-button button-default is-half'
      }
    });
    if (shouldCloseModal) {
      resetBooking();
      isActive.value = false;
    }
  }
  catch (error) {
    if (error) return;
  }
};

const resetBooking = (stayOnSameStep?: boolean) => {
  patientBooking.value = getPatientBookingInitialState();
  furthestStepReached.value = 1;
  selectedDateOfScreening.value = null;
  freeTimeslots.value = [];
  selectedTimeSlot.value = undefined;
  if (!stayOnSameStep) switchToStep(1);
};

const bookForAnotherPersonAtSameSc = async () => {
  resetBooking();
  freeTimeslots.value = await getFreeTimeslots();
};

const bookForAnotherPersonAtDifferentSc = () => {
  isActive.value = false;
  resetBooking();
};

const editBooking = (booking: IPatientBooking) => {
  patientBooking.value = booking;
  switchToStep(1);
};

const deleteBooking = async (booking: IPatientBooking) => {
  const shouldDeleteBooking = true;
  // const shouldDeleteBooking = await $dialog.show({
  //   message: 'Are you sure you want to delete this booking. This action is irreversable',
  //   cancelButton: {
  //     text: 'No',
  //     class: 'button-important is-one-third'
  //   },
  //   confirmButton: {
  //     text: 'Yes',
  //     class: 'button-default is-two-thirds'
  //   },
  //   hasDivider: true,
  //   container: '.ow-popup-body'
  // });
  if (shouldDeleteBooking) {
    // patientBooking.value = getPatientBookingInitialState();
    const indexOfBooking = completedBookings.value.findIndex(completedBooking => completedBooking.tempId === booking.tempId);
    completedBookings.value.splice(indexOfBooking, 1);

    // Comparing to the length + 1 because we splice right before this
    if ((completedBookings.value.length + 1) === 1) {
      currentStep.value = 1;
      furthestStepReached.value = 1;
      selectedTimeSlot.value = undefined;
      selectedDateOfScreening.value = null;
    }
  };
};

interface IPatientData {
  dob: Date
  sex: string
}

interface IPatientDataResult {
  patientData?: IPatientData
  patient?: IPatient
}

interface IPatientResponse {
  result: IPatientDataResult
}

const lookupPatient = async (isValid: boolean) => {
  if (isValid && patientBooking.value && patientBooking.value.screeningCentre) {
    const response = await $fetch('/api/endpoints/get-patient', {
      method: 'POST',
      body: { idNumber: patientBooking.value?.patient.identity_number, organizationId: patientBooking.value.screeningCentre.organizationId }
    }) as IPatientResponse;
    const patientData = response.result.patientData;
    if (patientData && patientData.dob) {
      if (patientData.dob && patientData.sex) {
        const patientDateOfBirth = new Date(patientData.dob);
        patientDateOfBirth.setHours(12, 0, 0, 0);
        patientBooking.value.patient.dob = patientDateOfBirth;
        patientBooking.value.patient.sex = patientData.sex;
      }
    }
    else if (response.result.patient) {
      const patient = response.result.patient;
      if (patient && patient._id) {
        patientBooking.value.patientId = patient._id;
        patientBooking.value.patient.title = patient.title;
        patientBooking.value.patient.name = patient.name;
        patientBooking.value.patient.surname = patient.surname;
      }
      currentPatientExists.value = true;
      switchToStep(4);
    }
  }
};

const getMedicalAidNames = async () => {
  const response = await $fetch<IMedicalAidName[]>('/api/endpoints/get-m-aid-names', {
    method: 'POST',
    body: {}
  });

  const medicalAidsRaw = response;

  mAidNameValues.value = medicalAidsRaw?.map((value: IMedicalAidName) => {
    return { dataValue: value._id, displayValue: value.name };
  });
};

const getMedicalAidPlans = async (medicalAidId: string) => {
  const response = await $fetch<IMedicalAidPlan[]>('/api/endpoints/get-m-aid-plans', {
    method: 'POST',
    body: { medicalAidId }
  });

  const medicalAidsRaw = response;

  mAidPlanValues.value = medicalAidsRaw?.map((value: IMedicalAidPlan) => {
    return { dataValue: value._id, displayValue: value.name };
  });
};

const mAidNameSelected = async () => {
  if (!patientBooking.value || !patientBooking.value.patient || !patientBooking.value.patient.fk_medical_aid) return;
  const medicalAidNameId = patientBooking.value.patient.fk_medical_aid;
  await getMedicalAidPlans(medicalAidNameId);
};

defineExpose({
  switchToStep
});
</script>

<style lang='scss'>
.ow-patient-booking-button {
  background-color: #4b99d4;
  color: #fff;
  border-radius: 6px;
  padding: 0.5em 6em;
  letter-spacing: 1px;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  border: none;
  filter: none;
  transition: filter 0.25s ease;
  &.button-primary {
    background-color: #0e365d;
  }
  &.button-important {
    background-color: #d61f38;
  }

  &:hover:not(:disabled) {
    cursor: pointer;
    filter: brightness(1.25);
    transition: filter 0.25s ease;
  }
  &:active:not(:disabled) {
    transform: translateY(2px);
  }
  &:disabled {
    opacity: 0.5;
  }
}

.ow-patient-booking-input-date {
  width: 50%;
  margin: 0 auto;
}

.ow-patient-booking-timeslot-list {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
  & .ow-patient-booking-timeslot {
    margin: 10px;
    flex: 0 1 calc(calc(100% / 6) - 20px);
    & .ow-patient-booking-timeslot-input {
      display: none;
      &:checked {
        & + .ow-patient-booking-timeslot-label {
          transform: scale(1.05);
          background-color: #f1f4ffd2;
          outline: 2px solid #0e365d;
          transition: transform 0.2s ease, background-color 0.2s ease, outline 0.2s ease;
        }
      }
    }
    & .ow-patient-booking-timeslot-label {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background-color: #fbfbfb;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
      box-shadow: 2px 1px 4px -2px #0e365d;
      transform: scale(1.00);
      transition: transform 0.2s ease, background-color 0.2s ease;
      &:hover,
      &:focus {
        transform: scale(1.05);
        background-color: #f1f4ffd2;
        transition: transform 0.2s ease, background-color 0.2s ease;
      }
    }
  }
}

.ow-patient-booking-popup-text {
  text-align: start;
  letter-spacing: 1px;
  padding: 0 3rem;
  color: #144d79;

  & h2 {
    font-size: 1rem;
    margin: 1rem 0;
    font-weight: bolder;
    color: #135180;
  }

  & p {
    margin: 0;
    font-size: 1rem;
    font-weight: 500;
  }
}

.ow-patient-booking-submit-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  & .ow-button {
    height: 40px
  }
}

.ow-patient-details-wrapper {
  width: 100%;
  height: fit-content;
  &.medical-aid-wrapper {
    min-height: 30vh;
  }
}

.ow-patient-booking-final-step {
  width: 100%;
  padding-bottom: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // justify-content: center;
  flex: 1 0 100%;
  & .ow-patient-booking-final-step-box {
    border: 4px solid transparent;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 20px;
    box-shadow: 1px 4px 4px -1px #b8b8b88c, 1px 6px 12px 0px #b8b8b8a5, inset 0px 0px 0px 2px #4a6b84;
  }
  & .ow-patient-booking-final-step-header {
    letter-spacing: 1px;
    & h2 {
      font-size: 22px;
    }
    & h3 {
      margin-top: 0;
      font-size: 16px;
      font-weight: 500;
    }
  }
  & .ow-patient-booking-cards-list {
    display: flex;
    gap: 15px;
    list-style-type: none;
    margin: 0;
    padding: 20px 0px;
    overflow-x: scroll;
    & .ow-patient-booking-card {
      flex: 1 0 400px;
      display: flex;
      flex-direction: column;
      max-width: 400px;
      background-color: #fff;
      position: relative;
      margin: 0 auto;
      & .ow-patient-booking-card-text {
        min-height: 2rem;
        line-height: 1rem;
        padding: 0.5rem 0;
        box-sizing: border-box;
        color: #0e365d;
      }
      & .ow-patient-booking-card-buttons {
        display: flex;
        flex-direction: row;
        position: absolute;
        right: 10px;
        bottom: 10px;
        gap: 5px;
        & .ow-patient-booking-card-button {
          width: 30px;
          height: 30px;
          background-color: #4a6b84;
          border-radius: 10px;
          border: none;
          padding: 5px;
          transform: scale(1);
          transition: transform 0.15s ease;
          &:hover {
            cursor: pointer;
            transform: scale(1.075);
            transition: transform 0.15s ease;
          }
          &:active {
            transform: translateY(2px);
          }
          & .os-icon {
            width: 100%;
            height: 100%;
            background-color: #fff;
          }
        }
      }
    }
  }
  & .ow-patient-booking-final-step-buttons {
    padding: 0;
    align-items: center;
    & .ow-book-another {
      flex: 0 1 60%;
      display: flex;
      flex-wrap: wrap;
      & h3 {
        flex: 1 0 100%;
      }
      & .ow-patient-booking-button {
        flex: 1 1 250px;
      }
    }
    & .ow-or {
      flex: 0 0 10%;
      padding-top: 50px;
      text-align: center;
    }
    & .ow-finish {
      padding-top: 50px;
      flex: 1 1 250px;
      & .ow-patient-booking-button {
        width: 100%;
      }
    }
    & .ow-patient-booking-button {
      font-size: 14px;
    }
  }
}

.ow-patient-booking-step-back-button {
  border-radius: 8px;
  border: none;
  color: #d61f38;
  box-sizing: border-box;
  background-color: transparent;
  padding: 5px;
  font-size: 16px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 10px;
  height: 40px;
  transform: scale(1);
  transition: transform 0.15s ease;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
    transition: transform 0.15s ease;
  }
  & .os-icon {
    background-color: #d61f38;
    width: 20px;
    height: 20px;
  }
  & .ow-patient-booking-step-back-button-text {
    height: 1em;
    font-weight: 600;
    letter-spacing: 1px;
  }
}

.ow-patient-booking-footer {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  & .ow-patient-booking-steps {
    display: flex;
    gap: 20px;
    list-style-type: none;
    padding: 0;
    margin: 0;
    & .ow-patient-booking-step {
      background-color: #c9c9c9;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      &.is-active {
        background-color: #0e365d;
      }
    }
  }
}
</style>
